package org.mkui.component

import react.FC

class ReactComponent(val element: FC<*>) : CPComponent {
    override val nativeComponent: FC<*> = element
}
